/**
 * « Se souvenir de moi » (habillage v1, ADR-092) : le **seul** module du front qui touche au
 * stockage du navigateur, et seulement pour l'adresse e-mail de connexion — aucune donnée
 * d'authentification (ADR-091 §6). Une garde de test (`test/guards.test.ts`) le vérifie. Lecture et
 * écriture sous try/catch : en navigation privée ou si le stockage est bloqué, la page fonctionne
 * sans mémoire.
 */

export const REMEMBERED_EMAIL_KEY = 'ayumia.signin.email';

export function readRememberedEmail(): string {
  try {
    return window.localStorage.getItem(REMEMBERED_EMAIL_KEY) ?? '';
  } catch {
    return '';
  }
}

/** `null` efface l'adresse mémorisée. */
export function rememberEmail(email: string | null): void {
  try {
    if (email === null) window.localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    else window.localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
  } catch {
    // Stockage indisponible : rien n'est mémorisé.
  }
}
